import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import styled from 'styled-components'
//import { useAlert } from 'react-alert'
//import { useDispatch } from 'react-redux'

import CloseIcon from '../../../../image/close_icon.png'

/* 縦並 */
const Wrap = styled.div`
  display:flex;
  flex-flow: column;
`
/* 項目 */
const Item = styled.div`
  display: flex; /* 横並び */
  flex-flow: row nowrap;
  text-align: left;
  vertical-align: middle;
`

const AlertModal  = (props) => {
  const {
    modalIsOpen,
    setIsOpen,
    healthCareData,
  } = props
  //const dispatch = useDispatch();
  //const alert = useAlert();

  // モーダル
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      //opacity: 0.8,
      padding: '10px',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)'
    },
    overlay: {
      //background: 'rgba(0, 0, 0, 0.7)',
      zIndex: 15
    }
  }

  //ダイアログ開いた時の処理
  function afterOpenModal () {
    //();
  }

  function closeModal () {
    setIsOpen(false);
  }

  useEffect(() => {
  }, [modalIsOpen])

  // 描画時に一度だけ実行
  useEffect(() => {

  }, [])

  return (
    <Modal
      isOpen={modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel='Alert Modal'
      ariaHideApp={false}
    >
      <div style={{ width:'400px', height:'330px', marginLeft:'1rem' }}>
        <Wrap>
          <div style={{ height:'20px', marginLeft:'auto', marginRight:'10px', marginTop:'10px', cursor: 'pointer'}}>
            <img alt='閉じる' className='close' src={CloseIcon} title={'ダイアログを閉じる'} width="12px" height="12px" onClick={closeModal} />
          </div>
        </Wrap>
        <Wrap style={{marginTop:'0.25rem'}}>
          <Item style={{marginLeft:'0.5rem', marginBottom:'1rem', fontWeight:'bold'}}>アラート発生項目</Item>
          {healthCareData.sleepTimeAlertFlag > 0 &&
            <Item style={{marginLeft:'2rem', marginTop:'1rem'}}>睡眠時間が短いです</Item>
          }
          {healthCareData.sleepScoreAlertFlag > 0 &&
           <Item style={{marginLeft:'2rem', marginTop:'1rem'}}>睡眠スコアが低いです</Item>
          }
          {healthCareData.fatigueAlertFlag > 0 &&
            <Item style={{marginLeft:'2rem', marginTop:'1rem'}}>疲労が高いです</Item>
          }
          {healthCareData.heartRateAlertFlag > 0 &&
            <Item style={{marginLeft:'2rem', marginTop:'1rem'}}>心拍数に問題があります</Item>
          }
          {healthCareData.week40overtimeFlag > 0 &&
            <Item style={{marginLeft:'2rem', marginTop:'1rem'}}>週40時間をオーバーです</Item>
          }
          {healthCareData.worktimeDailyOvertimeFlag > 0 &&
            <Item style={{marginLeft:'2rem', marginTop:'1rem'}}>作業時間（日）がオーバーです</Item>
          }
          {healthCareData.worktimeWeeklyOvertimeFlag > 0 &&
            <Item style={{marginLeft:'2rem', marginTop:'1rem'}}>作業時間（週）がオーバーです</Item>
          }
          {healthCareData.worktimeMonthlyOvertimeFlag > 0 &&
            <Item style={{marginLeft:'2rem', marginTop:'1rem'}}>作業時間（月）がオーバーです</Item>
          }
        </Wrap>
      </div>
    </Modal>
  )
}

AlertModal.propTypes = {
  modalIsOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  healthCareData: PropTypes.object,
}

export default AlertModal
